import Image from 'next/legacy/image';
import CallToAction from './CallToAction';
import { StaticImageData } from 'next/image';

type Props = {
  imageClassName?: string;
  imageSrc: StaticImageData;
  imageAlt: string;
  supTitle: string;
  title: string;
  subTitle?: string;
  children?: React.ReactNode;
};

export default function ImageHero({
  imageClassName,
  imageSrc,
  imageAlt,
  supTitle,
  title,
  subTitle,
  children,
}: Props) {
  return (
    <div className="relative">
      <div className="absolute inset-0">
        <Image
          src={imageSrc}
          alt={imageAlt || 'EnergyPal'}
          className={`object-cover w-full h-full ${imageClassName || ''}`}
          layout="fill"
          quality={100}
          priority
        />
      </div>
      <div className="relative px-4 py-8 sm:px-6 sm:py-12 lg:py-16 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <CallToAction subTitle={subTitle} supTitle={supTitle} title={title}>
            {children}
          </CallToAction>
        </div>
      </div>
    </div>
  );
}
